<template>
  <div :class="isOpen">
    <div class="modal-background"></div>
    <div class="modal-content">
      <!-- Any other Bulma elements you want -->
      <div class="box">
        <h3>הוסף ל{{sub.fullname}}</h3>
        <div class="field">
          <div class="control duration">
            <input class="input is-info" type="number" :placeholder="durationPlaceholder"
            v-model="duration">
          </div>
        </div>

        <div class="control">
          <label class="radio">
            <input type="radio" value="days" v-model="durationType">
            ימים
          </label>
          <label class="radio">
            <input type="radio" value="months" v-model="durationType">
            חודשים
          </label>
        </div>
        <div class="has-text-left">
          <button class="button is-info"
          @click="updateNextPayment">עדכן</button>
        </div>

      </div>
    </div>
    <button class="modal-close is-large" aria-label="close"
    @click="closeModal"></button>
  </div>
</template>

<script>
export default {
  data(){
    return {
      durationType: 'days',
      duration: '',
    }
  },
  computed: {
    isOpen(){
      if(this.$store.state.modalShow){
        return 'modal is-active';
      }
      return 'modal';
    },
    sub(){
      return this.$store.state.modalSub;
    },
    durationPlaceholder(){
      if(this.durationType === 'days'){
        return 'מספר ימים';
      }
      return 'מספר חודשים';
    }

  },

  methods: {
    closeModal(){
      this.$store.dispatch('closeModal');
      this.duration = '';
    },
    updateNextPayment(){
      const payload = {
        durationType: this.durationType,
        duration: this.duration,
        subId: this.sub.id,
      }

      this.$store.dispatch('updateNextPayment', payload);
    }
  }
}
</script>

<style lang="scss">
.radio {
  display: inline-block;
  min-width: 80px;
}

.duration {
  direction: ltr;
}
</style>
